import React from 'react';
import { Link } from 'react-router-dom';
import UseProductCartPage from './UseProductCartPage';
import { RxCross2 } from 'react-icons/rx';
import { Minus, Plus } from 'lucide-react';
import { AiOutlineHome } from 'react-icons/ai';
import { FaChevronRight } from 'react-icons/fa6';
import CouponPage from './Components/CouponPage';
import ProductCartMobilePage from './Components/ProductCartMobilePage';
import EmptyCartModal from './Components/EmptyCartModal';
import Namsteji_Manikchand_Icon from '../../../../assets/images/Namsteji_Manikchand_Icon.svg';
import config from '../../../../config/environment';

const ProductCartPage: React.FC = () => {
  const serverUrl = config.SERVER_URL;
  const { states, cartItemPlusMinus, emptyCart, handleApply } = UseProductCartPage();
  const itemsArr = states.cartDataArr?.items ?? [];
  return (
    <>
      {/* desktop view lg&xl */}
      <div className='hidden sm:hidden md:hidden lg:block'>
        <div className=' bg-[#F5F5F5] py-8 px-4 hidden sm:hidden md:hidden lg:block xl:block'>
          <nav className='flex items-center text-base gap-2 mx-[10%]'>
            <Link to='/home'>
              <AiOutlineHome className='text-black font-semibold size-6 cursor-pointer hover:text-[#4A2D1A]' />
            </Link>
            <FaChevronRight className='text-black font-semibold size-3' />
            <Link to='/products'>
              <span className='text-black text-base font-poppins'>Products</span>
            </Link>
            <FaChevronRight className='text-black font-semibold size-3' />
            <span className='text-base font-rubik text-orange-950'>My Shopping Cart</span>
          </nav>
        </div>

        <div className='flex items-center justify-center my-2 sm:my-2 md:my-2 lg:my-4 '>
          <div className='mx-[.5%] sm:mx-[.5%] md:mx-[1%] lg:mx-[10%] py-4'>
            <h2 className='text-xl sm:text-xl md:text-2xl lg:text-3xl font-bold text-[#4A2D1A] mb-2 flex items-center justify-center font-rubik'>
              {' MY SHOPPING CART'}
            </h2>
            {!states.showNullDivNotProduct && (
              <div className='flex flex-col lg:flex-row items-start justify-center gap-4 p-4'>
                {/* Left - Cart Items */}
                <div className='flex-1'>
                  <div className='bg-white border rounded-md shadow'>
                    <div className='grid grid-cols-5 px-4 pt-4 text-[#808080] border-b pb-2 mb-2 text-xs md:text-sm text-end font-poppins'>
                      <div>PRODUCT</div>
                      <div>PRICE</div>
                      <div>QUANTITY</div>
                      <div>SUBTOTAL</div>
                      <div></div>
                    </div>

                    {itemsArr &&
                      itemsArr.length > 0 &&
                      itemsArr.map((item: any, index: number) => {
                        const isDisabled = !item.tax_amount;
                        return (
                          <div
                            key={index}
                            className={`grid grid-cols-5 items-center border-b px-4 py-3 text-xs md:text-sm font-poppins ${
                              isDisabled ? 'opacity-80 pointer-events-none select-none' : ''
                            }`}
                          >
                            {/* Product */}
                            <div className='flex gap-2'>
                              <img
                                src={
                                  item.web_item_name.thumbnail
                                    ? `${serverUrl}${item.web_item_name.thumbnail}`
                                    : Namsteji_Manikchand_Icon
                                }
                                alt=''
                                className='w-12 h-12 object-cover rounded'
                              />
                              <div>
                                <div className='font-medium text-base'>{item.item_name}</div>
                                <div className='text-base text-[#9E9E9E]'>
                                  {item.uom_conversion ? 'Pack of ' + item.uom_conversion?.conversion_factor : ''}
                                </div>
                              </div>
                            </div>

                            {/* Price */}
                            <div className='text-gray-700 font-medium text-end text-base'>
                              ₹{item.website_item ? item.website_item.toFixed(2) : ''}
                            </div>

                            {/* Quantity */}
                            <div className='flex justify-end items-end gap-2'>
                              <div className='flex items-center  border border-[#C12E2A] rounded-lg px-2 py-1 '>
                                <button
                                  className='flex items-center justify-center'
                                  onClick={() => !isDisabled && cartItemPlusMinus(item.qty - 1, item.item_code, 'plus')}
                                  disabled={isDisabled}
                                >
                                  <Minus size={16} className='text-red-600' />
                                </button>
                                <span className='px-4 text-base font-medium'>{item.qty}</span>
                                <button
                                  className='flex items-center justify-center'
                                  onClick={() => !isDisabled && cartItemPlusMinus(item.qty + 1, item.item_code, 'plus')}
                                  disabled={isDisabled}
                                >
                                  <Plus size={16} className='text-red-600' />
                                </button>
                              </div>
                            </div>

                            {/* Subtotal */}
                            <div className='text-end text-base'>
                              ₹{item.tax_amount ? item.tax_amount.toFixed(2) : '00.00'}
                            </div>

                            {/* Remove */}
                            <div
                              className='text-gray-500 cursor-pointer flex justify-end items-end'
                              onClick={() => !isDisabled && cartItemPlusMinus(0, item.item_code, 'plus')}
                            >
                              <RxCross2 className='w-6 h-6 text-end border rounded-full p-1' />
                            </div>
                          </div>
                        );
                      })}

                    <div className='flex justify-between mt-4 px-4 pb-4 font-poppins'>
                      <Link
                        to='/products'
                        className='px-4 py-2 text-[#4D4D4D] rounded-lg bg-[#E6EDF5] hover:bg-[#d3e3f4] text-sm font-poppins'
                      >
                        Add More
                      </Link>
                      <button
                        className='px-4 py-2 text-[#4D4D4D] rounded-lg bg-[#E6EDF5] hover:bg-[#d3e3f4] text-sm font-poppins'
                        onClick={() => emptyCart()}
                      >
                        Empty Cart
                      </button>
                    </div>
                  </div>

                  {/* Coupon */}
                  {states.listOfCoupen.current && states.listOfCoupen.current.length > 0 && (
                    <CouponPage
                      inputCode={states.inputCode}
                      handleApply={handleApply}
                      listOfCoupen={states.listOfCoupen}
                      appliedCouponName={states.appliedCouponName.current}
                      handleRemoveCoupon={states.handleRemoveCoupon}
                    />
                  )}
                </div>

                {/* Right - Cart Total */}
                <div className='w-full lg:w-1/4'>
                  <div className='bg-white border shadow rounded-md p-4 font-poppins'>
                    <h3 className='text-lg font-bold mb-3'>Cart Total</h3>
                    <div className='flex justify-between pb-2 text-sm'>
                      <span className='text-[#4D4D4D]'>Subtotal:</span>
                      <span className='font-medium'>₹{states.cartDataArr?.net_total?.toFixed(2)}</span>
                    </div>
                    <div className='flex justify-between border-t py-2 text-sm'>
                      <span className='text-[#4D4D4D]'>
                        Discount{' '}
                        {states.cartDataArr?.additional_discount_percentage
                          ? '(' + states.cartDataArr?.additional_discount_percentage + ') % OFF'
                          : ''}
                        :
                      </span>
                      <span className='font-medium'>
                        ₹{' '}
                        {states.cartDataArr?.discount_amount ? states.cartDataArr?.discount_amount.toFixed(2) : '0.00'}
                      </span>
                    </div>
                    <div className='flex justify-between border-t py-2 text-sm'>
                      <span className='text-[#4D4D4D]'>Effective subtotal:</span>
                      <span className='font-medium'>
                        ₹{' '}
                        {states.cartDataArr?.discount_amount ? states.cartDataArr?.discount_amount.toFixed(2) : '0.00'}
                      </span>
                    </div>
                    <div className='flex justify-between border-t py-2 text-sm'>
                      <span className='text-[#4D4D4D]'>GST:</span>
                      <span className='font-medium'>₹{states.cartDataArr?.tax_amount?.toFixed(2)}</span>
                    </div>
                    <div className='flex justify-between border-t py-2 text-sm'>
                      <span className='text-[#4D4D4D]'>Shipping:</span>
                      <span className='text-green-600 font-medium'>Free</span>
                    </div>
                    <div className='flex justify-between border-t py-2 text-base'>
                      <span className='text-[#4D4D4D]'>Grand Total:</span>
                      <span className='font-semibold'>₹{states.cartDataArr?.grand_total?.toFixed(2)}</span>
                    </div>

                    <button className='w-full mt-4 bg-[#C12E2A] hover:bg-[#a4221dff] text-white font-medium py-2 rounded text-base'>
                      <Link to='/product/billing-info'>Proceed to checkout</Link>
                    </button>
                  </div>
                </div>
              </div>
            )}

            {states.showNullDivNotProduct && <EmptyCartModal />}
          </div>
        </div>
      </div>
      {/* Mobile view */}
      <ProductCartMobilePage
        cartDataArr={states.cartDataArr}
        emptyCart={emptyCart}
        cartItemPlusMinus={cartItemPlusMinus}
        inputCode={states.inputCode}
        handleApply={handleApply}
        listOfCoupen={states.listOfCoupen}
        showCoupenModalMobile={states.showCoupenModalMobile}
        setShowCoupenModalMobile={states.setShowCoupenModalMobile}
        showNullDivNotProduct={states.showNullDivNotProduct}
        appliedCouponName={states.appliedCouponName.current}
        handleRemoveCoupon={states.handleRemoveCoupon}
      />
    </>
  );
};

export default ProductCartPage;
